/** Общая ошибка парсинга шаблона */
export class ParsingError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'ParsingError';
    }
}
